import { isEmail } from '@webapp/common/lib/ui';

// TODO purge, use forms lib

export const validateEmpty = (field: Array<any> | string | number | boolean): string => {
    const message = 'поле должно быть заполнено';

    if (Array.isArray(field) && !field.length) {
        return message;
    }

    if (typeof field === 'string' && !field.trim()) {
        return message;
    }

    if (!field) {
        return message;
    }

    return null;
};

export const validateEmail = (email: string, required?: boolean): string => {
    if (required && validateEmpty(email)) {
        return 'электронная почта обязательна для заполнения';
    }

    if (email && !isEmail(email)) {
        return 'некорректный адрес электронной почты';
    }

    return null;
};

export const validatePassword = (password: string, required?: boolean, isValidatePassword?: boolean): string => {
    if (
        isValidatePassword &&
        password &&
        (password.trim().length < 8 ||
            !password.match('[A-Z]') ||
            !password.match('[a-z]') ||
            (!password.match('[0-9]') && !password.match('[!@#$%^&*_]')))
    ) {
        return 'error';
    }

    if (required && validateEmpty(password)) {
        return 'пароль обязателен для заполнения';
    }

    if (password && password.trim().length < 6) {
        return 'Не короче 6 символов';
    }
};

const codeRe = /^\d{6}$/;

export const validateCode = (code: string, required?: boolean): string => {
    if (required && validateEmpty(code)) {
        return 'код не введен';
    }

    if (code && !codeRe.test(code)) {
        return 'код должен быть 6 символов';
    }
};
